import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IBatchTrashFoldersParams {
  folderIds: string[];
}

export async function batchTrashFolders({
  folderIds,
}: IBatchTrashFoldersParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/folder/trash/bulk', {
    method: 'POST',
    body: { folderIds },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to trash folders',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
